<div class="audio-playlist-container" [class.to-centre]="queData.length == 0">
    @if(queueExpanded){
        <div class="queue-breadcrums">
            <span (click)="shrinkViewall()" class="queue-breadcrums-padding breadcrums-queue-play">{{configService.localeKeys?.kws_kw_player_def}}</span>
            <span class="queue-breadcrums-padding">></span>
            <span class="queue-breadcrums-padding breadcrums-queue-clr">{{configService.localeKeys?.kws_kw_queue_def}}</span>
        </div>
        <div class="queue-current-play">
            <span>Current Playing</span>
        </div>
    }

    @if(currentPlayingContentGeoAvailability){
        <div class="audio-playlist-top" [class.audio-playlist-top-expand]="queueExpanded">
                <img class="audio-playlist-img" [src]="settingsService.getImage(currentPlayingContent?.poster_square, 'card')">
                <div class="details-container">
                    @if(currentPlayingType == 'audio'){
                        <span class="title" [class.title-expand]="queueExpanded">{{currentPlayingContent.title}}</span>
                        <span class="casting" [class.casting-expand]="queueExpanded">{{currentPlayingContent.cast}}</span>
                    }
                    @if(currentPlayingType == 'podcast'){
                        @if(!episodeFirstPlayTrigger){
                            <span class="title">{{currentPlayingContent.title}}</span> 
                        }@else{
                            <span class="title">{{currentPlayingEpisode.title}}</span> 
                        }
                        <div class="tags">
                            @for(item of currentPlayingContent.genre; track item){
                                <span>{{item}}</span>
                                @if(!$last){
                                    <span> | </span>
                                }
                            }
                        </div>
                    }
                    @if(!queueExpanded){
                        <div class="action-wishlist-container">
                            @if(actionButton){
                                @if(showLogin){
                                    <span class="action-button mylist-text" (click)="entitlementFuncEmit()">
                                        {{configService.localeKeys?.['common_keys.login.text'] || "Login"}}
                                    </span>
                                }
                                @if(!showLogin){
                                    <span class="action-button mylist-text" (click)="entitlementFuncEmit()">
                                        {{configService.localeKeys?.['common_keys.subscribe_to_watch.btn'] || 'Subscribe to Watch'}}
                                    </span>
                                }
                            }
                            @if(currentPlayingContent.wishlist_status){
                                <span class="wishlist-btn" (click)="removeFromWishlist('current', currentPlayingContent)">
                                    <img class="mylist-img" src="branding/theme/assets/static_assets/ic-aud-pod-filled-heart-on-dbg.svg">
                                    <span class="mylist-text">{{"Remove from List"}}</span>
                                </span>
                            } @else {
                                <span class="wishlist-btn" (click)="addToWishlist('current', currentPlayingContent)">
                                    <img class="mylist-img" src="branding/theme/assets/static_assets/ic-aud-pod-empty-heart-on-dbg.svg">
                                    <span class="mylist-text">{{"Add to List"}}</span>
                                </span>
                            }           
                        </div>
                    }
                </div>
         
        </div>
    }
    @else{
        <div class="audio-playlist-top-geo" [class.audio-playlist-top-expand]="queueExpanded">
            <img class="audio-playlist-top-geo-img" src="branding/theme/assets/static_assets/ic-exclaimation-for-dbg.svg" alt="">
            <span class="audio-playlist-top-geo-txt">{{configService.localeKeys?.['player.content_not_avaliable.text']}}</span> 
        </div>
    }

    @if(queData.length != 0){
        <div class="audio-playlist-queue-container" [class.audio-playlist-queue-container-expand]="queueExpanded">
            @if(currentPlayingType == 'audio'){
                <div class="queue-title-header">
                    @if(queueExpanded){
                        <div class="queue-title">{{ configService.localeKeys?.['audio.upcoming.text'] || "Upcoming"}}</div>
                    } @else {
                        <div class="queue-title">{{ configService.localeKeys?.kws_kw_queue_def || "Queue"}}</div>
                    }
                    @if( !queueExpanded && (queData.length > hideQueueLength)){
                        <div class="queue-title queue-viewall" (click)="expandViewall()">{{ configService.localeKeys?.homepg_menu_viewall|| "View all"}}</div>
                    }
                </div>
                <div class="queue-detail-container">
                    @for(content of queData;track content){
                        @if($index  < hideQueueContent ){
                            <div class="queue">
                                <div class="queue-detail">
                                    <img class="playing-img" [src]="settingsService.getImage(content?.poster_square, 'card')">
                                    <div class="playing-detail">
                                        <span class="queue-title-inside">{{content?.title}}</span>
                                        <span class="queue-casting">{{content?.cast}}</span>
                                    </div>
                                </div>
                                <div class="queue-btn-section">
                                    <div class="round-container">
                                        @if(!content.wishlist_status){
                                            <img class="playlist-like-icon" (click)="addToWishlist('list',content)"  src="branding/theme/assets/static_assets/ic-aud-pod-empty-heart-on-dbg.svg">
                                        }@else{
                                            <img class="playlist-like-icon" (click)="removeFromWishlist('list', content)"  src="branding/theme/assets/static_assets/ic-aud-pod-filled-heart-on-dbg.svg">
                                        }
                                    </div>
                                    <img class="playlist-play-icon" (click)="audioPlayInit($index)" src="branding/theme/assets/static_assets/ic-aud-pod-play-on-dbg.svg">
                                </div>
                            </div>
                        }
                    }
                </div>
            }
            @if(currentPlayingType == 'podcast'){
                <div class="queue-podacst-header">
                    <div class="queue-podcast-header-title" [class.selected-tile]="selectedType == 'episode'" (click)="changeType('episode')">{{ configService.localeKeys?.kws_kw_episds_def || "Episodes"}}</div>
                    <div class="queue-podcast-header-title" [class.selected-tile]="selectedType == 'about'" (click)="changeType('about')">{{ configService.localeKeys?.kw_about|| "About"}}</div>
                </div>
                <div class="queue-detail-container">
                @if(selectedType == 'episode'){
                    @for(content of queData;track content){
                        <div class="queue-container">
                            <div class="queue-podcast">
                                <div class="queue-detail">
                                    <img class="playing-img" [src]="settingsService.getImage(content?.poster_square, 'card')">
                                    <div class="playing-detail">
                                        <span class="queue-title-inside">{{content?.title}}</span>
                                        <div class="date-detail">
                                            <span class="queue-date-time">{{content?.publish | queueListDate}} </span>
                                            <span class="queue-date-time-seperator"> | </span>
                                            <span class="queue-date-time">{{content?.duration_sec | queueListDuration}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="queue-btn-section">
                                    <div class="progress-over-img-container">
                                        @if(currentPlayingEpisodeIndex == $index){
                                            <round-progress
                                            [current]="currentProgressValue"
                                            [max]="100"
                                            [color]="seekbarProgressColor"
                                            [background]="seekbarBaseColor"
                                            [radius]="21"
                                            [stroke]="4"
                                            [rounded]="true"
                                            [clockwise]="true"
                                            [responsive]="false"
                                            [duration]="800"
                                            [animation]="'easeInOutQuart'"
                                            [animationDelay]="0"
                                            />
                                            @if(!isPlaying){
                                                <img (click)="podcastPlayInit(content?.position)" class="playlist-play-icon playlist-play-icon-prog" src="branding/theme/assets/static_assets/ic-aud-pod-play-on-dbg.svg">
                                            }@else if(isPlaying){
                                                <img (click)="podcastPlayPause(content?.position)" class="playlist-play-icon playlist-play-icon-prog" src="branding/theme/assets/static_assets/ic-aud-pod-pause-on-dbg.svg">
                                            }
                                        }@else {
                                            <img (click)="podcastPlayInit(content?.position)" class="playlist-play-icon" src="branding/theme/assets/static_assets/ic-aud-pod-play-on-dbg.svg">
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="queue-description">{{content?.description}}</div>
                            <div class="horz-seperator"></div>
                        </div>
                    }
                }
                @if(selectedType == 'about'){
                    <div class="queue-about">
                        <p class="queue-about-text">{{currentPlayingContent?.description}}</p>
                    </div>
                }
                </div>
            }
        </div>
    }
</div>
